export const menu = [
  {
    name: "Home",
    link: "/app",
    icon: "icon icon-dashboard",
    innerLink: true,
  },
  {
    title: "Crypto",
    submenu: [
      {
        name: "Overview",
        link: "/app/alerts",
        icon: "icon icon-database-warning",
        innerLink: true,
      },

      {
        name: "Last Alerts",
        link: "/app/alerts-history",
        icon: "icon icon-bell",
        innerLink: true,
      },
      {
        name: "Volume Change",
        link: "/app/crypto-coins",
        svg: "report",
        innerLink: true,
      },
      {
        name: "Available Coins",
        link: "/app/available-coins",
        icon: "las la-coins",
        innerLink: true,
      },
      {
        name: "Alert Report",
        link: "/app/alert-report",
        svg: "bot",
        innerLink: true,
      },
      {
        name: "Events",
        link: "/app/events",
        icon: "icon icon-calendar",
        innerLink: true,
      },
      {
        name: "Dollar Cost Avg",
        link: "/app/dollar-cost-avg",
        icon: "icon icon-money",
        innerLink: true,
      },
      {
        name: "Portfolio Manager",
        link: "/app/portfolio",
        svg: "stock",
        innerLink: true,
        needLogin: true,
      },
      {
        name: "Fear & Greed Index",
        link: "/app/fear-greed",
        svg: "percentage",
        innerLink: true,
      },
      // {
      //     name: "Indicators",
      //     link: "/app/indicators",
      //     icon: "las la-chart-line",
      //     innerLink: true,
      // },
      {
        name: "News",
        link: "/app/news",
        icon: "icon icon-news",
        innerLink: true,
      },
    ],
  },
  {
    submenu: [
      {
        name: "Account",
        link: "/app/account",
        icon: "icon icon-user",
        innerLink: true,
        needLogin: true,
      },
      // {
      //     name: "Notifications Config",
      //     link: "/app/notifications-config",
      //     icon: "las la-wrench",
      //     innerLink: true,
      // },
      {
        name: "Support",
        link: "/app/ticket",
        icon: "icon icon-ticket",
        innerLink: true,
        needLogin: true,
      },
      {
        name: "Public Telegram Channel",
        link: "https://t.me/invalert",
        svg: "telegram",
        outerLink: true,
      },
      {
        name: "Private Telegram Channel",
        svg: "telegram",
        modal: true,
        needLogin: true,
      },
    ],
  },
];
